import React from "react";

function OscillatingGranulator() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* BREADCRUMB SECTION */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Oscillating Granulator</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Oscillating Granulator</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay" 
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN SECTION */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN PRODUCT IMAGE */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/29.png"
                        alt="Oscillating Granulator"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Oscillating Granulator</h2>

                  {/* DESCRIPTION */}
                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Oscillating Granulator is widely used for wet and dry 
                      granulation processes in pharmaceutical, chemical, and food 
                      industries. It produces uniform granules with minimal fines 
                      and controlled particle size reduction.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      The oscillating rotor breaks down materials through gentle 
                      crushing and screening, ensuring consistency and preserving 
                      granule structure. Built with SS contact parts and robust 
                      construction, it ensures long-lasting performance.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/29.png"
                            alt="Granulator Side View"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/30.png"
                            alt="Granulator Closeup"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-OG-1</td>
                          <td>DPM-OG-2</td>
                          <td>DPM-OG-3</td>
                        </tr>

                        <tr>
                          <td>Production Capacity</td>
                          <td>30–50 kg/hr</td>
                          <td>80–120 kg/hr</td>
                          <td>150–250 kg/hr</td>
                        </tr>

                        <tr>
                          <td>Rotor Speed</td>
                          <td>80 RPM</td>
                          <td>100 RPM</td>
                          <td>110 RPM</td>
                        </tr>

                        <tr>
                          <td>Screen Diameter</td>
                          <td>6 inch</td>
                          <td>8 inch</td>
                          <td>10 inch</td>
                        </tr>

                        <tr>
                          <td>Motor Power</td>
                          <td>1 HP</td>
                          <td>2 HP</td>
                          <td>3 HP</td>
                        </tr>

                        <tr>
                          <td>Oscillation</td>
                          <td>± 90°</td>
                          <td>± 90°</td>
                          <td>± 90°</td>
                        </tr>

                        <tr>
                          <td>Material of Construction</td>
                          <td colSpan="3">SS 304 / SS 316 Contact Parts</td>
                        </tr>

                        <tr>
                          <td>Dimensions (L × W × H)</td>
                          <td>900 × 700 × 1100 mm</td>
                          <td>1100 × 800 × 1250 mm</td>
                          <td>1300 × 900 × 1350 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>180 kg</td>
                          <td>260 kg</td>
                          <td>340 kg</td>
                        </tr>

                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">
                  
                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>

                    <ul>
                      <li>
                        <a href="/roll-compactor-machine">
                          Roll Compactor Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-mill">
                          Multi Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/mass-mixer">
                          Mass Mixer Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>
                    </ul>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default OscillatingGranulator;
